import { render, staticRenderFns } from "./AppSimpleSelector.vue?vue&type=template&id=5b9b179d&scoped=true&"
import script from "./AppSimpleSelector.vue?vue&type=script&lang=ts&"
export * from "./AppSimpleSelector.vue?vue&type=script&lang=ts&"
import style0 from "./AppSimpleSelector.vue?vue&type=style&index=0&id=5b9b179d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b9b179d",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VImg } from 'vuetify/lib/components/VImg';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemGroup } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VMenu } from 'vuetify/lib/components/VMenu';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VImg,VList,VListItem,VListItemGroup,VListItemTitle,VMenu,VTextField})
